import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AdminSidebar, adminNavItems } from './AdminSidebar';
import { cn } from '../../lib/utils';
import logoColor from '../../assets/logo_color.png';

export const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  return (
    <div className="min-h-screen flex bg-cream2">
      <AdminSidebar />

      <div className="flex-1 min-w-0 flex flex-col">
        {/* Mobile top bar: sidebar is desktop-only (lg:flex) */}
        <div className="lg:hidden sticky top-0 z-40 bg-cream2 border-b border-outlineVarWarm">
          <div className="flex items-center gap-2 px-4 h-14">
            <img src={logoColor} alt="Obros" className="w-6 h-6 object-contain" />
            <span className="text-sm font-bold text-onSurface">Panel administrativo</span>
          </div>
          <nav className="flex gap-1 px-3 pb-2 overflow-x-auto scrollbar-hide">
            {adminNavItems.map((item) => {
              const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    'shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-colors',
                    isActive ? 'bg-primary-500 text-white' : 'bg-surface text-onSurface-var'
                  )}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>

        <main className="flex-1">{children}</main>
      </div>
    </div>
  );
};
